export default __webpack_public_path__ + "static/media/condition.762d4ab2.md";